import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import style from "../solo.module.sass";
import { Select, Icon, Input, Button } from 'antd';
import VariableAcl from "./VariableAcl";
import variableAclIcon from "../../../../../assets/svg/solo/variableAclConfigured.svg"
import emptyVariableAclIcon from "../../../../../assets/svg/solo/variableAclNotConfigured.svg"
import CompletionCriteriaPopup from "../codeEditor/completionCriteriaEditor";
const { Option } = Select;

const Form = (props: any) => {/* eslint-disable */
    const { form, nodeDetail, elements, widgetDrawer, showVariableAcl, setShowVariableAcl, setAclIcon } = props;
    const [formProperty, setFormProperty]: any = useState({ nodeId: null })
    const [formName, setFormName]: any = useState("");
    const [name, setName]: any = useState("");
    const [nodes, setNodes]: any = useState(null);
    const [nextNode, setNextNode]: any = useState(null);
    const [selectedForm, setSelectedForm]: any = useState(null);
    const [formKey, setFormKey]: any = useState(null)
    const [variableAcl, setVariableAcl] = useState({});
    const [setupActiveTab, setSetupActiveTab] = useState("freeze")
    const [teardownActiveTab, setTeardownActiveTab] = useState("freeze")
    const { ModalSelectedValues } = useSelector((state: any) => state.solo)
    const [modalOpen, setmodelOpen]: any = useState(false)
    const [completionCriteria,setCompletionCriteria]=useState("")

    useEffect(() => {
        if (ModalSelectedValues && ModalSelectedValues.id === nodeDetail.id) {
            setSelectedForm(ModalSelectedValues.name)
            setFormKey(ModalSelectedValues.key)
        }
        if (form && ModalSelectedValues) {
            form.map((f: any) => {
                return (f.displayName === ModalSelectedValues.name) &&
                    setFormKey(f.formKey)
            })
        }
    }, [ModalSelectedValues, form])

    useEffect(() => {
        let targetNodeFind: any;
        const findNextNode = elements.filter((el: any) => { return (el.source === nodeDetail.id) })
        targetNodeFind = elements.filter((el: any) => { return (el.target === nextNode) })
        if (findNextNode.length) {
            setNextNode(findNextNode[0].target)
        } else if (findNextNode.length === 0 && targetNodeFind.length === 0) {
            setNextNode("")
        }
        let arr: any = []
        elements.forEach((e: any) => {
            if (e.data && e.data.type && e.data.type !== "start" && e.data.type !== "error" && e.id !== props.nodeDetail.id) {
                arr.push(e)
                setNodes(arr)
            }
        })
    }, [elements])

    useEffect(() => {
        if (form) {
            form.map((f: any) => {
                return (f.displayName === selectedForm) &&
                    setFormKey(f.formKey)
            })
        }
    }, [selectedForm])


    useEffect(() => {
        setSetupActiveTab("freeze")
        setTeardownActiveTab("freeze")
        setAclIcon(emptyVariableAclIcon)
        setShowVariableAcl(false)
        if (nodeDetail.data.propertyDetails) {
            if (nodeDetail.data.propertyDetails.variableAcl?.setup?.freeze || nodeDetail.data.propertyDetails.variableAcl?.setup?.unfreeze || 
                nodeDetail.data.propertyDetails.variableAcl?.setup?.hide || nodeDetail.data.propertyDetails.variableAcl?.setup?.unhide || 
                nodeDetail.data.propertyDetails.variableAcl?.teardown?.freeze || nodeDetail.data.propertyDetails.variableAcl?.teardown?.unfreeze || 
                nodeDetail.data.propertyDetails.variableAcl?.teardown?.hide || nodeDetail.data.propertyDetails.variableAcl?.teardown?.unhide) {
                setAclIcon(variableAclIcon)
            }
            if (nodeDetail.type === "form" && !nodeDetail.data.propertyDetails.key) {
                setName(nodeDetail.data.propertyDetails.name ? nodeDetail.data.propertyDetails.name : nodeDetail.id);
                setFormName(nodeDetail.data.propertyDetails.name ? nodeDetail.data.propertyDetails.name : nodeDetail.id)
                setSelectedForm(nodeDetail.data.propertyDetails.selectedForm);
                setFormKey(nodeDetail.data.propertyDetails.formKey)
                setVariableAcl(nodeDetail.data.propertyDetails?.variableAcl || {})
                setCompletionCriteria(nodeDetail.data.propertyDetails?.completionCriteria || "")
                const findNextNode = elements.filter((el: any) => { return (el.source === nodeDetail.id) })
                if (findNextNode.length) {
                    //const nextNode = elements.filter((el: any) => { return el.id === findNextNode[0].target })
                    setNextNode(findNextNode[0].target)
                } else {
                    setNextNode("")
                }
            } else {
                const { propertyDetails } = props.nodeDetail.data
                setName(nodeDetail.data.propertyDetails.name)
                setFormName(nodeDetail.data.propertyDetails.name)
                if (nodeDetail.data.propertyDetails.key) {
                    form && form.map((f: any) => {
                        return (f.formKey === props.nodeDetail.data.propertyDetails.key) &&
                            setSelectedForm(f.displayName)
                    })
                }
                const findNextNode = elements.filter((el: any) => { return (el.source === nodeDetail.id) })
                if (findNextNode.length) {
                    //const nextNode = elements.filter((el: any) => { return el.id === findNextNode[0].target })
                    setNextNode(findNextNode[0].target)
                } else {
                    setNextNode("")
                }
                setFormKey(nodeDetail.data.propertyDetails.key)
                setVariableAcl(nodeDetail.data.propertyDetails?.variableAcl || {})
                setCompletionCriteria(nodeDetail.data.propertyDetails?.completionCriteria || "")
                setFormProperty({
                    type:"form",
                    nodeId: nodeDetail.id,
                    name: propertyDetails && propertyDetails.name,
                    formKey: propertyDetails && propertyDetails.key,
                    selectedForm: propertyDetails && propertyDetails.selectedForm,
                    nextNode: nextNode,
                    variableAcl,
                    completionCriteria,
                })
            }
        } else if (!nodeDetail.data.propertyDetails) {
            if (nodeDetail.type === "form") {
                setName(nodeDetail.id);
                setFormName(nodeDetail.id)
                setSelectedForm(null);
                setNextNode("")
                setVariableAcl({})
                setCompletionCriteria("")
            }
        }
    }, [nodeDetail.id, widgetDrawer])

    useEffect(() => {
        props.onUpdateProperties(formProperty)
    }, [formProperty])

    useEffect(() => {
        if (formName) {
            setFormProperty({
                nodeId: nodeDetail.id,
                name: formName,
                completionCriteria,
                 type:"form",
            })
        }
    }, [formName])

    const formsSubmit = () => {
        props.setWidgetDrawer(false)
        setFormProperty({
            nodeId: nodeDetail.id,
            name: name,
            formKey: formKey,
            selectedForm: selectedForm,
            idChange: true,
            nextNode: nextNode,
            variableAcl,
            completionCriteria,
            type: "form"
        })
    }

    const openModal = () => {
        setmodelOpen(true)
    }

    const closeModal = () => {
        setmodelOpen(false)
    }

    const eventHandler = (i: any, value: any) => {
        setCompletionCriteria(value)
    }
  
    return ( <>
        {!showVariableAcl && <>
        <div style={{ display: "flex", flexDirection: "column" }}>
            <div className={style.conditionInput}>
                <div style={{ width: "100%" }}>
                    <div className={style.label} >
                        <label >Name</label>
                    </div>
                    <Input style={{
                        height: "44px",
                        color: "#000610",
                        fontSize: 15,
                        border: props.nameCheck ? "1px solid #FF0000" : "1px solid #909BAD"
                    }}
                        disabled={props.lock}
                        value={name}
                        required={true}
                        placeholder="Enter Node Name"
                        onChange={(e) => { setName(e.target.value); setFormName(e.target.value) }}
                    />
                    {(props.nameCheck || !name) && <p style={{
                        color: "#FF0000",
                        opacity: props.nameCheck || !name ? 1 : 0,
                        position: "relative",
                        textAlign: "center",
                        margin: "5px",
                        fontSize: 14
                    }}>{!name ? "Name shouldn't be empty" : "Name already exist"}</p>}
                </div>
            </div>
            <div style={{ borderBottom: "1px solid rgb(202, 213, 233)", margin: "20px 20px" }}></div>
            <div style={{ display: "flex", flexDirection: "column", width: "100%", padding: "0px 15px" }}>
                <div
                    className={style.label}
                    style={{ color: "#3c434a" }}
                >
                    <label >Next Node</label>
                </div>
                <Select
                    showSearch
                    onChange={(e: any) => setNextNode(e)}
                    suffixIcon={<Icon style={{ fontSize: "20px", margin: -5 }} type="caret-down" />}
                    disabled={props.lock}
                    value={nextNode || undefined}
                    placeholder="Select the next node"
                    optionLabelProp="label"
                    style={{
                        width: "100%",
                        borderRadius: 8,
                        color: "#000610",
                        fontSize: 15
                    }}
                    mode="default"
                    size="large"
                    filterOption={(input, option: any) => {
                        return (option && option.props)
                            ?
                            option.props.label.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                            : false
                    }}
                >
                    {nodes && nodes.map((el: any) => {
                        return <Option
                            key={el.id}
                            value={el.id}
                            label={el && el.data && el.data.propertyDetails && el.data.propertyDetails && el.data.propertyDetails.name || el.id}>
                            <div
                                style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <div
                                    style={{ display: "flex", flexDirection: "row" }}>
                                    <img alt="icons" src={el.data.icon} />
                                    <p
                                        style={{
                                            height: el.data.type === "end" ? 13 : "",
                                            width: el.data.type === "end" ? 13 : "",
                                            marginLeft: "8px",
                                            marginTop: "12px",
                                            color: el.id === nextNode ? "#0F66C8" : "#000610"
                                        }}
                                    >
                                        {el && el.data && el.data.propertyDetails && el.data.propertyDetails && el.data.propertyDetails.name || el.id}
                                    </p>
                                </div>
                                {el.id === nextNode &&
                                    < Icon type="check" style={{ color: "#0F66C8" }} />}
                            </div>
                        </Option>
                    })}
                </Select>
            </div>
            <div style={{ borderBottom: "1px solid rgb(202, 213, 233)", margin: "20px 20px" }}></div>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "5px 15px" }}>
                <div className={style.label}>
                    <label>Form Name</label>
                </div>
                <Select
                    showSearch
                    suffixIcon={<Icon style={{ fontSize: "20px", margin: "-5px" }} type="caret-down" />}
                    disabled={props.lock}
                    placeholder="Select the form"
                    value={selectedForm || undefined}
                    size="large"
                    style={{
                        width: "100%",
                        borderRadius: 8,
                        //border: "1px solid #CAD5E9",
                        color: "#000610",
                        fontSize: 15,
                    }}
                    optionLabelProp="label"
                    onChange={(e: any) => setSelectedForm(e)}
                    filterOption={(input, option: any) => {
                        return (option && option.props && option.props.children) ?
                            option.props.children.props.children[0].props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                            : false
                    }}
                >
                    {form && form.map((item: any) => {
                        return <Option
                            key={item.formId}
                            value={item.displayName}
                            label={item.displayName}>
                            <div
                                style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <p style={{ marginTop: "10px", color: item.displayName === selectedForm ? "#0F66C8" : "#000610" }}>
                                    {item.displayName}
                                </p>
                                {item.displayName === selectedForm &&
                                    < Icon type="check" style={{ color: "#0F66C8" }} />}
                            </div>
                        </Option>
                    })}
                </Select>
                </div>
                <div style={{ borderBottom: "1px solid rgb(202, 213, 233)", margin: "20px 20px" }}></div>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "5px 15px" }}>
                    <div className={style.label} style={{ color: "#3c434a" }}>
                        <label >Completion Criteria</label>
                        <a target="_blank" href="https://jsonschemalint.com/" style={{ marginLeft: 5 }}>Reference</a>
                    </div>
                    <Input
                        disabled={props.lock}
                        style={{
                            width: "100%",
                            height: "44px",
                            fontSize: "15px",
                            cursor: props.lock ? "not allowed" : "pointer",
                            color: "#000610",
                            border: "1px solid #909BAD"
                        }}
                        autoComplete="off"
                        onClick={() => { openModal(); }}
                        placeholder="Add Completion Criteria"
                        value={completionCriteria}
                    />
                    {modalOpen && !props.lock &&
                        <CompletionCriteriaPopup
                            type="completionCriteria"
                            values={completionCriteria}
                            handleExpression={eventHandler}
                            close={closeModal}
                        />}
                </div>
            <div className={style.footer}>
                {!props.nameCheck && !props.lock && <Button
                    disabled={!name}
                    style={{ backgroundColor: "#51808C", color: "#FFFFFF", width: "100%", height: 50 }}
                    onClick={formsSubmit}>APPLY</Button>}
            </div>
        </div>
        </>}
        {showVariableAcl && <VariableAcl
            variableAcl={variableAcl}
            setVariableAcl={setVariableAcl}
            teardownActiveTab={teardownActiveTab}
            setTeardownActiveTab={setTeardownActiveTab}
            setupActiveTab={setupActiveTab}
            setSetupActiveTab={setSetupActiveTab}
            setShowVariableAcl={setShowVariableAcl}
            name={name}
            lock={props.lock}>
        </VariableAcl>}
    </>)
}

export default Form